module.exports = __webpack_public_path__ + "img/stop-fill.2456991a.svg";